module.exports = __webpack_public_path__ + "7445afc806248dfffa079c89b0f7e1aa.pdf";